import React, { useContext } from 'react';

import { AuthApi } from '../apis';
import { api } from '../api';

const AuthApiContext = React.createContext(new AuthApi(api));

export const AuthApiProvider = AuthApiContext.Provider;
export const useAuthApi = (): AuthApi => useContext(AuthApiContext);
